import {IRegexHelper} from "./regexTypes";

// Pattern matches: a-z, а-яё (Russian letters including ё), spaces, hyphens, single quotes, double quotes, 0-9
// Flags: i (case-insensitive), u (unicode)
// This matches the backend validation pattern: /^[a-zа-яё\s\-\'\\"0-9]+$/isu
export const CompanyNameRegex: IRegexHelper = {
  pattern: /^[a-zа-яё\s\-'"0-9]+$/iu,
  error: "Invalid characters in company name",
}

